module.exports = __webpack_public_path__ + "images/dingtalk/init-events-4224ef60b17e3107a15984d79c380cc9.png";